import { Button, Snackbar } from '@equinor/eds-core-react'
import { useAtomValue } from 'jotai'
import { ReactElement, useEffect, useState } from 'react'
import { snackbarMessageAtom } from '@/core/store/globalStore'

export default function Toast(): ReactElement {
    const snackbarMessage = useAtomValue(snackbarMessageAtom)
    const [isSnackbarVisible, setIsSnackbarVisible] = useState(false)
    const [currentMessage, setCurrentMessage] = useState<string | null>(null)

    useEffect(() => {
        if (snackbarMessage?.content) {
            setCurrentMessage(snackbarMessage.content)
            setIsSnackbarVisible(true)
        }
    }, [snackbarMessage, currentMessage])

    return (
        <Snackbar
            autoHideDuration={7000}
            open={isSnackbarVisible}
            onClose={() => setIsSnackbarVisible(false)}
            placement="bottom"
        >
            {currentMessage}
            <Snackbar.Action>
                <Button variant="ghost" onClick={() => setIsSnackbarVisible(false)}>
                    Close
                </Button>
            </Snackbar.Action>
        </Snackbar>
    )
}
